import * as React from "react";
import styled from "styled-components";
import { SIDEBAR_BG } from "../../settings/colors";
import { SIDEBAR_WIDTH, CONTENT_PADDING } from "../../settings/metrics";

import BrandLink from "./BrandLink";
import AccountSwitcher from "./AccountSwitcher";

const Sidebar = ({ children, ...otherProps }) => (
  <div {...otherProps}>
    <BrandLink />
    <div style={{ flex: 1, overflowY: "auto", marginTop: CONTENT_PADDING / 2 }}>
      {children}
    </div>
    <AccountSwitcher />
  </div>
);

const StyledSidebar = styled(Sidebar)`
  position: fixed;
  width: ${SIDEBAR_WIDTH}px;
  left: 0;
  top: 0;
  bottom: 0;
  background: ${SIDEBAR_BG};
  display: flex;
  flex-direction: column;
`;

export default StyledSidebar;



// WEBPACK FOOTER //
// ./src/components/sidebar/Sidebar.js